import * as React from 'react';
import AdminUpgradePlanForms from './AdminUpgradePlanForms';
import AdminUpgradePlanPaymentForm from './AdminUpgradePlanPaymentForm';
import AdminUpgradePlanQuoteForm from './AdminUpgradePlanQuoteForm';
import Input from 'components/Input';
import { OrganizationType } from 'globalTypes';
import { ReactStripeElements, injectStripe } from 'react-stripe-elements';
import AdminUpgradePlanOrganizationInfoForm from './AdminUpgradePlanOrganizationInfoForm';

import '../styles/AdminUpgradePlanContainer.scss';
export type UpgradePlanTabKey =
  | 'org-info'
  | 'quote'
  | 'payment'
  | 'purchase-complete'
  | 'contact-sales';

type PaymentMethod = 'card';

export type UpgradePlanData = {
  country?: string;
  state?: string;
  city?: string;
  orgUuid?: string;
  lat?: number;
  long?: number;
  teachersCount?: number;
  studentsCount?: number;
  comment?: string;
  requesterFirstName?: string;
  requesterLastName?: string;
  role?: string;
  phoneNumber?: string;
  requesterEmail?: string;
  orgName?: string;
  orgAddress?: string;
  orgType?: OrganizationType;
  startDate?: string;
  endDate?: string;
  price?: string;
  taxExempt?: boolean;
  tax?: string,
  billingFirstName?: string;
  billingLastName?: string;
  billingEmail?: string;
  useRequesterAsBillingContact?: boolean;
  adminVerificationUrl?: string;
};

export type UpgradePlanQuote = {
  orgName?: string;
  studentsCount?: number;
  shareToken?: string;
};

export type UpgradePlanTab = {
  tabKey: UpgradePlanTabKey;
  component: React.ComponentClass<any>;
  nextStep?: UpgradePlanTabKey;
  prevStep?: UpgradePlanTabKey;
  isComplete: boolean;
};

type Props = {};

type State = {
  upgradePlanData: UpgradePlanData;
  upgradePlanQuote: UpgradePlanQuote;
  currentTabKey: UpgradePlanTabKey;
  paymentMethod: PaymentMethod;
  cardValid: boolean;
  cardInputCompleted: boolean;
};

class AdminUpgradePlanContainer extends React.Component<
  Props & ReactStripeElements.InjectedStripeProps,
  State
> {
  constructor(props: Props) {
    super(props);
  }

  state: State = {
    upgradePlanData: {
      country: '',
      state: '',
      city: '',
      orgUuid: '',
      lat: 0,
      long: 0,
      teachersCount: 0,
      studentsCount: 0,
      comment: '',
      requesterFirstName: '',
      requesterLastName: '',
      role: '',
      phoneNumber: '',
      requesterEmail: '',
      orgName: '',
      orgAddress: '',
      orgType: OrganizationType.School,
      startDate: '',
      endDate: '',
      price: '',
      taxExempt: false,
      tax: '$0.00',
    },
    upgradePlanQuote: {
      orgName: '',
      studentsCount: 0,
      shareToken: '',
    },
    currentTabKey: 'org-info' as UpgradePlanTabKey,
    paymentMethod: 'card' as PaymentMethod,
    cardValid: false,
    cardInputCompleted: false,
  };

  saveAdminUpgradePlanData = (fields: UpgradePlanData, onSuccess: Function) => {
    this.setState({ upgradePlanData: fields });
    onSuccess();
  }

  onTaxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      upgradePlanData: {
        ...this.state.upgradePlanData,
        taxExempt: event.target.checked,
      }
    });
  }

  // TODO: Do some graphql mutations when you hit an end state
  // (get told that sales will reach out to you, or succeed in
  // buying the thing via credit card)

  render() {
    const { upgradePlanData, upgradePlanQuote, currentTabKey } = this.state;

    // TODO: handle loading state
    // TODO: handle error states

    const tabs = [
      {
        tabKey: 'org-info',
        component: AdminUpgradePlanOrganizationInfoForm,
        prevStep: undefined,
        nextStep: 'quote',
        isComplete: false, // TODO: fill in
      },
      {
        tabKey: 'quote',
        component: AdminUpgradePlanQuoteForm,
        prevStep: 'org-info',
        nextStep: 'purchase-complete',
        isComplete: false, // TODO: fill in
      },
      {
        tabKey: 'quote-review',
        component: AdminUpgradePlanPaymentForm,
        prevStep: 'quote',
        nextStep: 'purchase-complete',
        isComplete: false, // TODO: fill in
      },
      {
        tabKey: 'purchase-complete',
        component: Input, // TODO: swap for actual component
        prevStep: 'quote',
        nextStep: undefined,
        isComplete: false, // TODO: fill in
      },
    ] as UpgradePlanTab[];
    const currentTab = tabs.find(tab => tab.tabKey === currentTabKey);

    return (
      <div className="AdminUpgradePlanContainer">
        <AdminUpgradePlanForms
          tabs={tabs}
          currentTab={currentTab}
          fields={upgradePlanData}
          quote={upgradePlanQuote}
          onCardInputCompleted={() => this.setState({ cardInputCompleted: true })}
          onPersistState={this.saveAdminUpgradePlanData}
          onTaxChange={this.onTaxChange}
        />
      </div>
    );
  }
}

export { AdminUpgradePlanContainer };
export default injectStripe(AdminUpgradePlanContainer);
